import React from "react";
import { Upload, message } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const KycUploadField = ({ 
  label, 
  value, 
  onChange, 
  required = false, 
  disabled = false,
  maxSize = 2, // MB
  extra = null,
}) => {
  const props = {
    name: "file",
    multiple: false,
    disabled: disabled,
    accept: ".pdf,.jpg,.jpeg,.png",
    beforeUpload: (file) => {
      const isLtMax = file.size / 1024 / 1024 < maxSize;
      if (!isLtMax) {
        message.error(`File must be smaller than ${maxSize}MB!`);
        return Upload.LIST_IGNORE;
      }
      
      const isAcceptedType = ["application/pdf", "image/jpeg", "image/png"].includes(file.type);
      if (!isAcceptedType) {
        message.error("You can only upload PDF, JPG, or PNG files!");
        return Upload.LIST_IGNORE;
      }

      onChange(file);
      return false; // Prevent auto upload
    },
    onRemove: () => {
      onChange(null);
    },
    fileList: value ? [value] : [],
    maxCount: 1,
    showUploadList: true,
  };

  return (
    <div className="kyc-upload-field">
      <div style={{ marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <span style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>{label}</span>
          {required && <span style={{ color: "#ff4d4f", marginLeft: 4 }}>*</span>}
        </div>
        {extra && <div className="kyc-upload-extra">{extra}</div>}
      </div>
      <Dragger 
        {...props} 
        style={{ 
          background: "#fff", 
          border: "2px dashed #e1e1e1", 
          borderRadius: 12,
          padding: "20px 0"
        }}
      >
        <p className="ant-upload-drag-icon" style={{ marginBottom: 12 }}>
          <CloudUploadOutlined style={{ color: "#0474ba", fontSize: "32px" }} />
        </p>
        <p className="ant-upload-text" style={{ fontSize: "14px", fontWeight: 500, color: "#0474ba" }}>
          Upload {label || "Document"}
        </p>
        <p className="ant-upload-hint" style={{ fontSize: "12px", color: "#999" }}>
          Maximum size: {maxSize} MB
        </p>
      </Dragger>
    </div>
  );
};

export default KycUploadField;
